export default "__VITE_ASSET__Davk$Vlh__"